"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AccelerateYourSmeGrowth() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="22726" id="the-trading-edge" ref={sectionRef} className="relative w-full min-h-[90vh] flex items-center overflow-hidden dark bg-background text-foreground pt-20 pb-16 lg:pt-0 lg:pb-0">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {}
        <div className="absolute top-[-20%] right-[-10%] w-[70%] h-[150%] bg-gradient-to-b from-primary/10 to-transparent -rotate-12 blur-3xl" />
        {}
        <div className="absolute bottom-[-20%] left-[-10%] w-[50%] h-[100%] bg-gradient-to-t from-card/40 to-transparent rotate-12 blur-3xl" />
        
        {}
        <div className="absolute inset-0 opacity-[0.07]" style={{
        backgroundImage: `linear-gradient(var(--color-border) 1px, transparent 1px), linear-gradient(90deg, var(--color-border) 1px, transparent 1px)`,
        backgroundSize: '40px 40px'
      }} />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          
          {}
          <div className={`w-full lg:w-[60%] flex flex-col gap-8 transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <h1 className="font-sans text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black tracking-tighter leading-[1.05] text-foreground">
              <span className="bg-gradient-to-r from-slate-50 via-slate-300 to-slate-500 bg-clip-text text-transparent inline-block pb-2">
                The Future
              </span>
              <br />
              of Capital
            </h1>

            <p className="font-mono text-lg sm:text-xl md:text-2xl text-muted-foreground leading-relaxed max-w-2xl">
              Experience institutional-grade execution with 10ms latency. TradeSphere provides the liquidity and speed required for professional market participation.
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button asChild size="lg" className="h-16 px-10 text-lg rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-[0_0_25px_-5px_var(--color-primary)] transition-all duration-300 group">
                <Link to="#">
                  Start Trading
                  <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="h-16 px-10 text-lg rounded-sm border-border hover:bg-accent hover:text-accent-foreground transition-colors">
                <Link to="#">
                  View Markets
                </Link>
              </Button>
            </div>

            {}
            <div className="pt-8 flex items-center gap-8 text-sm text-muted-foreground font-mono uppercase tracking-widest">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-sm bg-primary animate-pulse" />
                <span>10ms Latency</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-sm bg-primary animate-pulse delay-150" />
                <span>Deep Liquidity</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-sm bg-primary animate-pulse delay-300" />
                <span>Global Markets</span>
              </div>
            </div>
          </div>

          {}
          <div className={`w-full lg:w-[40%] relative flex justify-center lg:justify-end transition-all duration-1000 delay-300 ease-out transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="relative w-full max-w-md aspect-square lg:aspect-[4/5]">
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-card/5 rounded-full blur-3xl animate-[pulse_4s_ease-in-out_infinite]" />
              
              {}
              <div className="relative w-full h-full animate-[bounce_6s_ease-in-out_infinite]">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604002/img/abstract_glass_sculpture_growth.png" alt="Abstract 3D glass sculpture representing upward momentum" className="w-full h-full object-contain drop-shadow-2xl opacity-90" />
                
                {}
                <div className="absolute top-1/4 -left-4 w-24 h-24 bg-primary/5 backdrop-blur-xl border border-primary/20 rounded-sm shadow-lg rotate-12 animate-[pulse_5s_ease-in-out_infinite_reverse]" />
                <div className="absolute bottom-1/4 -right-4 w-32 h-32 bg-card/40 backdrop-blur-xl border border-white/5 rounded-sm shadow-2xl -rotate-6 animate-[pulse_7s_ease-in-out_infinite]" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}